export const LoginLabel = {
    heading: "Sign In To Astro",
    login: "User Name",
    password: "Password",
    submit: "Login Now",
    forget_pass: "Forget Password ?"
};

